<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong><%= aee.ap %></strong>
			</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-3">
			<%- include('/ui/form', {
				params: [ 'aee_event', aee_event ],
				fields: [
					{
						type: 'date',
						name: 'event_d',
						title: 'Dátum'
					},
					{
						type: 'select',
						name: 'event',
						title: 'Esemény',
						params: {
							options: [
								{ value: 'start', label: 'Megszemélyesítés, üzembe helyezés' },
								{ value: 'mobile_contract_signed', label: 'Mobiladat szerződés aláírva' },
								{ value: 'mobile_contract_uploaded', label: 'Mobiladat szerződés feltöltve' },
								{ value: 'yearly_inspection_scheduled', label: 'Éves felülvizsgálat ütemezve' },
								{ value: 'yearly_inspection', label: 'Éves felülvizsgálat' },
								{ value: 'repair', label: 'Javítás' },
								{ value: 'rename', label: 'Átszemélyesítés' },
								{ value: 'stop', label: 'Felfüggesztés' },
								{ value: 'other', label: 'Egyéb' }
							],
							valueField: 'value',
							labelField: 'label',
						},
						unset_value: null
					},
					{
						type: 'textarea',
						name: 'notes',
						title: 'Megjegyzések',
						attributes: {
							style: 'height:200px;'
						}
					}
				]
			}) %>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-check me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async save () {
		await Anvil.exec('c_order/aee_event/action_save', Anvil.page.modal.aee_event)
	}
})
</script>
